import React, { useState } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { Rating } from "react-simple-star-rating";
import { BsCart } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai"; 
import pdf from "../../Assets/images/New/que-pdf.png";
import { Link, useNavigate } from "react-router-dom";
import "./CourseCardWithModal.scss";
import { purchaseStudentCourse } from "../../services/purchaseStudentCourse";
import { getSessionDataByStudentCourse } from "../../services/getSessionDataByStudentCourse";
import { Spinner } from "reactstrap";
const CourseCardWithModal = ({
  courseData,
  redirectData,
  modalOpen,
  toggleModal,
  setModalOpen,
  isLoggedIn = false,
}) => {
  const navigator = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
 const handleLoginRedirect = async () => {
  setIsSubmitting(true);
  try {
    navigator("/paynow", { state: redirectData });
    setModalOpen(false);
  } finally {
    setIsSubmitting(false); 
  }
};
  const handlePayment = async () => {
    setErrorMessage("");
    setIsSubmitting(true);
    try {
      const response = await purchaseStudentCourse({
        courseId: courseData._id,
        courseInnerType: courseData?.tempCourse?.courseType,
        courseInnerId: courseData?.tempCourse?.courseTypeId,
        price: courseData?.tempCourse?.coursePrice,
      });

      if (response.isSuccess) {
        localStorage("serviceType","CourseHelp");
        navigator(`/checkout`, {
          state: {
            paymentMethod: response?.data?.paymentMethod,
            questionDetails: response?.data,
          },
        });
        // if (response?.billingDetails) {
        //   const responseData = await getSessionDataByStudentCourse(response?.data);

        //   if (responseData.clientSecret) {
        //     navigator(`/course-checkout/${response.data._id}`, {
        //       state: {
        //         clientSecret: responseData.clientSecret,
        //       },
        //     });
        //   }
        // } else {
        //   // navigator(
        //   //   `/billingDetailscourse/${response?.data?.paymentMethod}/${response?.data?._id}`,
        //   //   { state: response?.data?._id }
        //   // );
        // }
      } else {
        setErrorMessage(response.message || "Purchase failed");
      }
    } catch (error) {
      setErrorMessage("An unexpected error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Modal isOpen={modalOpen} toggle={toggleModal} size="lg" centered>
      <button className="modal-close-btn" onClick={toggleModal}>
        <AiOutlineClose />
      </button>

      <ModalBody className="modal-body-custom">
        <div className="row" style={{ gap: "10px" }}>
          <div className="left-section  col-md-3 col-12 d-flex justify-content-center align-items-center">
            <div className="text-center mt-0">
              <img src={pdf} alt="cart-item" className="img-fluid" />
              <div className="mt-2">
                <Rating
                  size={22}
                  initialValue={parseFloat(courseData?.ratings)}
                  readonly
                />
              </div>
              <div className="mt-1" style={{ color: "#afabab" }}>
                <BsCart className="mx-2" /> {courseData?.purchases} purchases
              </div>
              <div className="mt-1" style={{ color: "#afabab" }}>
                {courseData?.views} Views
              </div>
            </div>
          </div>

          <div className="right-section col-md-8 col-12 d-flex justify-content-center align-items-center">
            <div className="w-100">
              <p className="text-start mb-2" style={{ color: "#afabab" }}>
                <span
                  className="fs-3 me-3"
                  style={{ color: "#6754E9", fontWeight: "600" }}
                >
                  {courseData?.courseName}
                </span>{" "}
                <span className="fs-6">
                  ({courseData?.university?.universityName}) -{" "}
                  {courseData?.tempCourse?.courseType}
                </span>
              </p>

              <p className="text-start mb-2 fs-4">
                <Link
                  to={`/course/${courseData?.university?.universityUrl}/${courseData?.courseUrl}`}
                  className="text-decoration-none"
                >
                  {courseData?.title}
                </Link>
              </p>

              <p
                className="text-start fs-5 sub-title"
                style={{ color: "#afabab" }}
              >
                {courseData?.subTitle}
              </p>
              <hr className="mt-3 mb-3" />
            </div>
          </div>

          <div className="mt-3 pay-btn-container d-flex justify-content-center align-items-center pe-3">
            <button
              className="gradient-btn"
              onClick={isLoggedIn ? handlePayment : handleLoginRedirect}
              disabled={isSubmitting}
            >
               {isSubmitting ? (
    <>
      <Spinner size="sm" color="light" className="me-2" />
      Processing...
    </>
  ) : (
    `$${courseData?.tempCourse?.coursePrice} PAY NOW`
  )}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CourseCardWithModal;
